export const fonts = [
  {
    family: `Proxima Nova`,
    weight: 400
  },
  {
    family: `Proxima Nova`,
    weight: 700
  }
];

export const OrganizationCoord = {
  latitude: 59.844674,
  longitude: 30.280430
};
